import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CategoryAddAction , CategoryGetAction } from "../../Redux/Action/Category";
import { ServiceAddAction, ServiceCategoryAddAction, ServiceDtailsAction } from "../../Redux/Action/ServiceAction";
import { decodeID, getLastURL } from "../../utils/Helper";
import { getDate } from "../../utils/Helper";
import { useIntl, FormattedMessage } from "react-intl";


function ServiceAdd() {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const log_in = useSelector((state: any) => state.ServiceDetailsState)
  const servicedata = useSelector((state: any) => state.ServiceDetailsState?.data?.data?.detail)
  const location = useLocation();
  const editId = getLastURL(location);
  const [loading  , setLoading] = useState(false)
  const [completed , setCompleted] = useState(0)
  const [pending , setPending] = useState(0)
  const [noShow , setNoShow] = useState(0)
  const [cancel , setCancel] = useState(0)
  const [cancelnycustomer , setCancelnycustomer ] = useState(0)


  useEffect(() => {
    setLoading(true)
    setCancel(0) 
    setCompleted(0)
    setNoShow(0)
    setPending(0)
    setCancelnycustomer(0)
    var params = {
      detail_id: decodeID(editId)
    };
    dispatch(ServiceDtailsAction(params))
    setTimeout(() => {
      setLoading(false)
    }, 400);
  }, [])

  useEffect(()=>{
  let completedbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "1")
  let pendingbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "0")
  let noShowbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "3")
  let canclebooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "2" && res.changed_by == "2")
  let cancleCustomerbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "2" && res.changed_by == '1')


  setCancel(canclebooking?.length) 
  setCompleted(completedbooking?.length)
  setNoShow(noShowbooking?.length)
  setPending(pendingbooking?.length)
  setCancelnycustomer(cancleCustomerbooking?.length)
  },[log_in.status])
  const handleBack = () => {
    navigate('/service')
    setCancel(0) 
    setCompleted(0)
    setNoShow(0)
    setPending(0)
    setCancelnycustomer(0)
  }
  return (
    <Fragment>
      { loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={<FormattedMessage id="service_details" />}
        breadcrumbs={{
          secLast: { 'link': '/service', 'name': <FormattedMessage id="service_list" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <div className="card">
          <div className="card-body">
            <div className="row gy-4">

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> <FormattedMessage id="service_name" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.name ? servicedata?.name : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="service_price" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.price ? servicedata.price : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="service_duration" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.duration ? servicedata?.duration : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> <FormattedMessage id="service_description" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.description ? servicedata?.description : '--'}</span>
                  </div>
                </div>
              </div>
                <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> <FormattedMessage id="service_category" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.category_details?.name ? servicedata?.category_details?.name : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="status" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.status == "1" ? <FormattedMessage id="active" /> : <FormattedMessage id="inactive" />}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="salon_name" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.salon_name}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="salon_phone_number" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.phone_country_code.split('+').length > 1 ? servicedata?.salon_details?.phone_country_code : `${servicedata?.salon_details?.phone_country_code} +`  } {servicedata?.salon_details?.phone_number}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="salon_email" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.email ? servicedata?.salon_details?.email : intl.formatMessage({ id: 'no_email' })}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="created_at" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.created_at ? getDate(servicedata?.created_at) : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="updated_at" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.created_at ? getDate(servicedata?.updated_at) : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_booked_service" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.book_services?.length > 0 ? servicedata?.book_services?.length : 0}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_completed_service" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{completed}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_cancelled_service_by_customer" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{cancelnycustomer}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_cancelled_service_by_salon" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{cancel}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_pending_service" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{pending}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"><FormattedMessage id="total_no_shown_up_service" /> :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{noShow}</span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} ><FormattedMessage id="back" /></button>
              </div>
            </div>
          </div>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default ServiceAdd;